import { render, staticRenderFns } from "./AppCommodity.vue?vue&type=template&id=1fffc71e&scoped=true&"
import script from "./AppCommodity.vue?vue&type=script&lang=js&"
export * from "./AppCommodity.vue?vue&type=script&lang=js&"
import style0 from "./AppCommodity.vue?vue&type=style&index=0&id=1fffc71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffc71e",
  null
  
)

component.options.__file = "AppCommodity.vue"
export default component.exports